import { createNewForecast } from '../../../core/api/forecast';
import { useSaveDataRequest } from '@futrli/shared-services';
import { useCallback } from 'react';

type RequestParams = Parameters<typeof createNewForecast>;
type ResponseDataType = Awaited<ReturnType<typeof createNewForecast>>;

/**
 * Creates a new forecast with the given data
 */
export const useCreateForecast = () => {
  const { save, ...rest } = useSaveDataRequest<ResponseDataType>();

  const createForecast = useCallback(
    (...params: RequestParams) => {
      return save(createNewForecast(...params));
    },
    [save]
  );

  return {
    createForecast,
    ...rest
  };
};
